import { RouterProvider } from '@tanstack/react-router'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { silentRefresh } from './lib/api'
import { router } from './router'
import './styles.css'

/**
 * L'access token vit en mémoire : après un rechargement il est vide.
 * On tente de le restaurer depuis le cookie HttpOnly *avant* le premier rendu,
 * sinon les gardes `beforeLoad` renverraient à tort vers /connexion.
 */
async function bootstrap() {
  await silentRefresh().catch(() => false)

  const rootEl = document.getElementById('root')
  if (!rootEl) throw new Error('Élément #root introuvable')

  createRoot(rootEl).render(
    <StrictMode>
      <RouterProvider router={router} />
    </StrictMode>,
  )
}

void bootstrap()
